"use client"

import CartTotals from "@modules/common/components/cart-totals"
import DiscountCode from "@modules/checkout/components/discount-code"
import ExpressCheckout from "@modules/checkout/components/express-checkout"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"

type SummaryProps = {
  cart: HttpTypes.StoreCart
  /** Order amount from which shipping is free (null: never free) */
  freeShippingFrom?: number | null
}

const Summary = ({ cart, freeShippingFrom }: SummaryProps) => {
  const subtotal = cart.item_subtotal ?? 0
  const remaining =
    freeShippingFrom != null ? freeShippingFrom - subtotal : null

  return (
    <div className="flex flex-col gap-y-4">
      {remaining === null ? null : remaining <= 0 ? (
        <p className="text-sm text-zl-green">
          <span className="font-bold">Tu pedido reúne los requisitos para el envío GRATIS.</span>{" "}
          Selecciona el envío estándar al tramitar el pedido.
        </p>
      ) : (
        <p className="text-sm">
          Añade{" "}
          <span className="font-bold text-zl-ink">
            {remaining.toLocaleString("es-ES", { style: "currency", currency: cart.currency_code.toUpperCase() })}
          </span>{" "}
          para conseguir envío GRATIS.
        </p>
      )}
      <CartTotals totals={cart} />
      {/* One page for everyone: saved details when logged in, a short form otherwise. */}
      <LocalizedClientLink
        href="/checkout"
        data-testid="checkout-button"
        className="zl-btn-accent w-full"
      >
        Tramitar pedido
      </LocalizedClientLink>
      <ExpressCheckout
        source={{ type: "cart", cartId: cart.id }}
        amount={Math.round((cart.total ?? 0) * 100)}
        currency={cart.currency_code}
      />
      <DiscountCode cart={cart} />
    </div>
  )
}

export default Summary
